import React from 'react';
import SideNav from './components/sideNav'
import Page01 from './components/page01'
import Page02 from './components/page02'
import Page04 from './components/page04'
import Page05 from './components/page05'
import Page06 from './components/page06'
import Loading from './components/loading'
import ReservePop from './components/reservePop'
import BindPop from './components/bindPop'
import InvitePop from './components/invitePop'
import LoginPop from './components/loginPop'
import RulePop from './components/rulePop'
import GiftPop from './components/giftPop'
import AccountPop from './components/accountPop'
import PageNav from './components/pageNav'
import { CSSTransition } from 'react-transition-group'
import axios from 'axios'
import { util } from './config'

class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      loadInfo: {
        count: 0,
        phone: "",
        roleid: "",
        invite: {
          code: "",
          count: 0,
          get1: 0,
          get2: 0,
          get3: 0,
        }
      },
      accountList: [],
      isSideProgressShow: true,
      activeBannerIndex: 1,
      invitedCode: '',
      isReservePopShow: false,
      isBindPopShow: false,
      isInvitePopShow: false,
      isLoginPopShow: false,
      isRulePopShow: false,
      isAccountPopShow: false,
      isGiftPopShow: false,
      isProgressHidden: true,
      loginType: 0,
      scrollTop: 0,
      giftLevel: 0,
      totalPercent: 0,
      entranceUrl: '',
      loopUrl: '',
      isLoadingEnter: false
    }
  }

  // reservepop
  toggleReservePop() {
    util.showToast({msg:'活动已结束!'});
    return;
    if (this.state.loadInfo.phone) {
      this.setState({ isReservePopShow: false })
      return;
    }
    window._hmt.push(['_trackEvent', '预约按钮', 'click']);
    const isReservePopShow = !this.state.isReservePopShow;
    this.setState({ isReservePopShow })
  }

  // invitePop
  toggleInvitePop = () => {
    util.showToast({msg:'活动已结束!'});
    return;
    if (!this.state.isInvitePopShow && !this.state.loadInfo.phone) {
      this.setState({ isLoginPopShow: true, loginType: 3 });
      return;
    }
    const isInvitePopShow = !this.state.isInvitePopShow;
    this.setState({ isInvitePopShow })
  }

  // rulePop
  toggleRulePop = () => {
    const isRulePopShow = !this.state.isRulePopShow;
    this.setState({ isRulePopShow })
  }


  // accountList
  toggleAccountPop = () => {
    util.showToast({msg:'活动已结束!'});
    return;
    const isAccountPopShow = !this.state.isAccountPopShow;
    // 未登录/未预约
    if (!this.state.loadInfo.phone) {
      this.setState({ isLoginPopShow: true, loginType: 1 });
      return;
    }
    // 弹窗关闭 && 已登录
    if (!this.state.isAccountPopShow && this.state.loadInfo.phone) {
      axios.get('https://actblood.web.sdo.com/Api/2020/1012/GetBindList.ashx').then(res => {
        if (res.data.success) {
          this.setState({ accountList: res.data.msg, isAccountPopShow })
        } else {
          util.showToast({ msg: res.data.msg, type: 'error' });
        }
      });
      return;
    }

    // 关闭弹窗
    this.setState({ isAccountPopShow })
  }

  // giftPop
  toggleGiftPop = (level) => {
    util.showToast({msg:'活动已结束!'});
    return;
    const isGiftPopShow = !this.state.isGiftPopShow;
    level && this.setState({ giftLevel: level });
    if (!this.state.loadInfo.phone) {
      this.setState({ isLoginPopShow: true, loginType: 2 });
      return;
    }
    if (!this.state.isGiftPopShow && this.state.loadInfo.phone) {
      axios.get('https://actblood.web.sdo.com/Api/2020/1012/GetBindList.ashx').then(res => {
        if (res.data.success) {
          this.setState({ accountList: res.data.msg, isGiftPopShow })
        } else {
          util.showToast({ msg: res.data.msg, type: 'error' });
        }
      });
      return;
    }
    this.setState({ isGiftPopShow });
  }

  toggleSideBar() {
    this.setState({ isSideProgressShow: !this.state.isSideProgressShow });
  }

  handleBannerClick(e) {
    let newIndex = 0;
    const direction = Number(e.currentTarget.dataset.direction);
    if (direction) {
      const tempIndex = this.state.activeBannerIndex + direction;
      if (tempIndex <= 0 || tempIndex > 4) { return; }
      newIndex = tempIndex;
    } else {
      newIndex = Number(e.currentTarget.dataset.index);
      if (newIndex === this.state.activeBannerIndex) {
        return;
      }
    }

    this.setState({
      activeBannerIndex: newIndex
    })
  }

  updateLoadInfo = () => {
    axios.get('https://actblood.web.sdo.com/Api/2020/1012/Load.ashx').then(res => {
      if (res.data.success) {
        this.setState({ loadInfo: res.data.msg })
      } else {
        util.showToast({ msg: res.data.msg, type: 'error' });
      }
    })
  }

  loginCb = () => {
    // loginType 
    // 1:绑定角色跳登陆
    // 2:领奖跳登录
    // 3:邀请跳登录
    // 4:登陆刷新数据
    switch (this.state.loginType) {
      case 1:
      case 2:
        axios.get('https://actblood.web.sdo.com/Api/2020/1012/GetBindList.ashx').then(res => {
          if (res.data.success) {
            this.setState({ accountList: res.data.msg, [this.state.loginType === 1 ? 'isAccountPopShow' : 'isGiftPopShow']: true, isLoginPopShow: false })
          } else {
            util.showToast({ msg: res.data.msg, type: 'error' });
          }
        });
        break;
      case 3:
        this.setState({ isInvitePopShow: true, isLoginPopShow: false });
        break;
      case 4:
        this.setState({ isLoginPopShow: false });
        break;
      default:
        alert(`loginType Error: code-${this.state.loginType}`)
        break;
    }
  }

  logOut = () => {
    axios.get('https://actblood.web.sdo.com/Api/2020/1012/PhoneOut.ashx').then(res => {
      if (res.data.success) {
        this.updateLoadInfo();
      } else {
        util.showToast({ msg: res.data.msg, type: 'error' });
      }
    })
  }

  UNSAFE_componentWillMount() {
    const code = getQueryVariable('code');
    if (code) {
      this.setState({ invitedCode: code });
    }
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      window.location.href = `https://actblood.web.sdo.com/Project/20200826/m/index.html${code ? ('?code=' + code) : ''}`
    }
  }

  componentDidMount() {
    this.updateLoadInfo();
    let timer = null;
    window.addEventListener('scroll', (e) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        this.setState({ scrollTop })
      }, 200)
    })
  }

  startLoading = () => {
    let video1Percent = 0;
    let video2Percent = 0;
    let totalPercent = 0;
    const video1 = loadVideo('https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/entrance.mp4');
    video1.onprogress = (e) => {
      video1Percent = Math.floor((e.loaded / e.total) * 50);
      totalPercent = video1Percent + video2Percent;
      this.setState({ totalPercent });
    }
    video1.onload = (e) => {
      if (e.target.status === 200) {
        var videoBlob = e.target.response;
        var blobSrc = URL.createObjectURL(videoBlob);
      }
      this.setState({ entranceUrl: blobSrc });
    }
    const video2 = loadVideo('https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/loop.mp4');
    video2.onprogress = (e) => {
      video2Percent = Math.floor((e.loaded / e.total) * 50);
      totalPercent = video1Percent + video2Percent;
      this.setState({ totalPercent });
    }
    video2.onload = (e) => {
      if (e.target.status === 200) {
        var videoBlob = e.target.response;
        var blobSrc = URL.createObjectURL(videoBlob);
      }
      this.setState({ loopUrl: blobSrc });
    }
  }

  render() {
    return (
      <div className="container" style={{ 'overflow': 'hidden', 'height': this.state.isLoadingEnter ? 'auto' : '100vh' }}>
        {!this.state.isLoadingEnter && <Loading totalPercent={this.state.totalPercent} loadingEnter={() => { this.setState({ isLoadingEnter: true }) }} startLoading={this.startLoading} />}
        <Page01 phone={this.state.loadInfo.phone} count={this.state.loadInfo.count} toggleReservePop={() => { this.toggleReservePop() }} logOut={this.logOut} showSideProgress={() => { this.setState({ isProgressHidden: false }) }} entranceUrl={this.state.entranceUrl} loopUrl={this.state.loopUrl} isLoadingEnter={this.state.isLoadingEnter} />
        {this.state.isLoadingEnter && <React.Fragment><Page02 level={getTargetLevel(this.state.loadInfo.count)} totalCount={this.state.loadInfo.count} />
          <Page04 phone={this.state.loadInfo.phone} toggleRulePop={this.toggleRulePop} toggleAccountPop={this.toggleAccountPop} toggleGiftPop={this.toggleGiftPop} info={this.state.loadInfo.invite} toggleInvitePop={this.toggleInvitePop} login={() => { this.setState({ loginType: 4, isLoginPopShow: true }) }} />
          <Page05 activeBannerIndex={this.state.activeBannerIndex} handleBannerClick={(e) => { this.handleBannerClick(e); }} />
          <Page06 />
          <PageNav scrollTop={this.state.scrollTop} />
          <SideNav phone={this.state.loadInfo.phone} scrollTop={this.state.scrollTop} isProgressHidden={this.state.isProgressHidden} level={getTargetLevel(this.state.loadInfo.count)} totalCount={this.state.loadInfo.count} toggleReservePop={() => { this.toggleReservePop() }} isSideProgressShow={this.state.isSideProgressShow} toggleSideBar={() => { this.toggleSideBar() }} />
          <CSSTransition in={this.state.isReservePopShow} timeout={500} classNames="fade">
            <ReservePop phone={this.state.loadInfo.phone} invitedCode={this.state.invitedCode} toggleReservePop={() => { this.toggleReservePop() }} updateLoadInfo={this.updateLoadInfo} goInvite={() => { this.toggleInvitePop(); this.setState({ isReservePopShow: false }); }} />
          </CSSTransition>
          <CSSTransition in={this.state.isBindPopShow} timeout={500} classNames="fade">
            <BindPop closeBindPop={() => { this.setState({ isBindPopShow: false }) }} updateLoadInfo={this.updateLoadInfo} phone={this.state.loadInfo.phone} />
          </CSSTransition>
          <CSSTransition in={this.state.isInvitePopShow} timeout={500} classNames="fade">
            <InvitePop inviteCode={this.state.loadInfo.invite.code} toggleInvitePop={this.toggleInvitePop} />
          </CSSTransition>
          <CSSTransition in={this.state.isLoginPopShow} timeout={500} classNames="fade">
            <LoginPop isLoginPopShow={this.state.isLoginPopShow} phone={this.state.loadInfo.phone} loginType={this.state.loginType} invitedCode={this.state.invitedCode} loginCb={this.loginCb} updateLoadInfo={this.updateLoadInfo} closeLoginPop={() => { this.setState({ isLoginPopShow: false }) }} />
          </CSSTransition>
          <CSSTransition in={this.state.isRulePopShow} timeout={500} classNames="fade">
            <RulePop toggleRulePop={this.toggleRulePop} />
          </CSSTransition>
          <CSSTransition in={this.state.isAccountPopShow} timeout={500} classNames="fade">
            <AccountPop accountList={this.state.accountList} toggleAccountPop={this.toggleAccountPop} goBind={() => { this.setState({ isBindPopShow: true, isAccountPopShow: false }) }} />
          </CSSTransition>
          <CSSTransition in={this.state.isGiftPopShow} timeout={500} classNames="fade">
            <GiftPop isGiftPopShow={this.state.isGiftPopShow} accountList={this.state.accountList} giftLevel={this.state.giftLevel} goBind={() => { this.setState({ isGiftPopShow: false, isBindPopShow: true }) }} updateLoadInfo={this.updateLoadInfo} toggleGiftPop={this.toggleGiftPop} />
          </CSSTransition>
        </React.Fragment>}
      </div>
    );
  }
}

function getTargetLevel(count) {
  let level = 0;
  if (count < 50000) { level = 0; }
  else if (count >= 50000 && count < 100000) { level = 1; }
  else if (count >= 100000 && count < 150000) { level = 2; }
  else if (count >= 150000 && count < 200000) { level = 3; }
  else if (count >= 200000) { level = 4 }
  return level;
}
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) { return pair[1]; }
  }
  return (false);
}
function loadVideo(url) {
  const req = new XMLHttpRequest();
  req.open('GET', url, true);
  req.responseType = 'blob';
  req.send();
  return req;
}
export default App;
